<div class="c-login">
  <div class="c-login__left">
    <div class="c-header">
      <img
        class="c-header__logo"
        ngSrc="/assets/logo-madero-gold.svg"
        width="150"
        height="50"
        priority
        alt="Logo Madero"
      />
      <h1 class="c-header__title">Gerenciador de Reservas</h1>
    </div>
  </div>
  <div class="c-login__right">
    <form
      class="c-login-form"
      appearance="outline"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
    >
      <mat-form-field appearance="outline" class="c-login-form__mail">
        <mat-label>Usuário</mat-label>
        <input
          matInput
          placeholder="Usuário..."
          formControlName="mail"
          placeholder="Insira seu usuário"
        />
        <mat-icon matSuffix color="primary" class="material-symbols-rounded">
          person
        </mat-icon>

        @if (form.get('mail')?.hasError('required')) {
          <mat-error>Insira seu e-mail</mat-error>
        }
        @if (form.get('mail')?.hasError('email')) {
          <mat-error>Coloque um e-mail válido</mat-error>
        }
        @if (form.hasError('required')) {
          <mat-error>Insira seu <strong>usuário.</strong></mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="c-login-form__password">
        <mat-label>Senha</mat-label>
        <input
          matInput
          [type]="hide ? 'password' : 'text'"
          formControlName="password"
          placeholder="Insira sua senha"
        />
        <button
          type="button"
          mat-icon-button
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon class="" color="primary" class="material-symbols-rounded">{{
            hide ? 'visibility_off' : 'visibility'
          }}</mat-icon>
        </button>
        @if (form.get('password')?.hasError('required')) {
          <mat-error>Insira uma senha</mat-error>
        }
      </mat-form-field>

      <!-- <div class="c-login-form__forgot">
            <p (click)="forgotPassword()">
              <span>Esqueci minha senha!</span>
            </p>
          </div> -->

      <button
        mat-raised-button
        class="c-btn c-btn--primary"
        type="submit"
        [disabled]="!form.valid"
      >
        @if (loading) {
          <div class="c-btn-spinner">
            <mat-spinner class="c-btn--spinner"></mat-spinner>
            <span>Carregando...</span>
          </div>
        } @else {
          <span>Entrar</span>
        }
      </button>
    </form>
  </div>
</div>
<footer class="c-footer">
  <span>Copyright Madero {{ currentYear }} -</span> Política e Termos de Uso
</footer>
